import React from "react";

let timeout;

function Search({fields, onSubmit}) {
    const [where, setWhere] = React.useState({});

    function onChange(value) {
        clearTimeout(timeout);

        timeout = setTimeout(() => {
            onSubmit(where);
        }, 300);
    }

    return (
        <div className="input-group">
            <i className="bi bi-search position-absolute"
               style={{
                   zIndex: 4,
                   width: "50px",
                   height: "50px",
                   lineHeight: "40px",
                   textAlign: "center"
               }}/>
            <input
                onChange={e => onChange(e.target.value)}
                type="search"
                className="form-control rounded-pill ps-5"
                placeholder="Search"/>
            <button className="btn btn-link border-0 p-0 ms-1 d-flex align-items-center" type="button">
                <i className="bi bi-filter fs-4"></i>Filter
            </button>
        </div>
    )
}

export default Search;